import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { replayForm } from 'src/shared/utils/replay-form';
import { DealDetailsFormGroup } from '../../deal-form.schema';
import { Invoice } from '@tradecafe/types/core';
import { DeepReadonly, findBrokerageInvoice } from '@tradecafe/types/utils';
import {
  OnDestroyMixin,
  untilComponentDestroyed,
} from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'tc-shipping-summary-v2',
  templateUrl: './shipping-summary.component.html',
  styleUrls: ['./shipping-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ShippingSummaryComponent extends OnDestroyMixin implements OnInit {
  @Input() formGroup: DealDetailsFormGroup;

  @Input() set invoices(invoices: DeepReadonly<Invoice[]>) {
    this.invoices$.next(invoices);
  }

  private readonly invoices$ = new BehaviorSubject<DeepReadonly<Invoice[]>>([]);

  protected isBrokerage$: Observable<boolean>;
  protected brok$: Observable<{
    estAmount: number;
    actAmount: number;
    currency: string;
  }>;

  ngOnInit() {
    this.isBrokerage$ = replayForm(this.formGroup.controls.dealType).pipe(
      map((type) => type === 'brokerage'),
    );

    this.brok$ = combineLatest([
      replayForm(this.formGroup),
      this.invoices$,
    ]).pipe(
      untilComponentDestroyed(this),
      distinctUntilChanged(),
      map(([f, invoices]) => ({
        estAmount: f.brokerageEstAmount,
        actAmount: this.invoiceTotal(invoices) || f.brokerageActAmount,
        currency: f.brokerageCurrency,
      })),
    );
  }

  private invoiceTotal(invoices: DeepReadonly<Invoice[]>): number {
    const brokerageInvoice = findBrokerageInvoice(invoices);
    if (!brokerageInvoice) {
      return 0;
    }

    return brokerageInvoice.total;
  }
}
